import { Box, Button, Card, CardBody, Flex, Text } from '@chakra-ui/react';
import { Link as RRLink } from 'react-router-dom';

import { PAYMENTS_DASHBOARD } from '../../../../constants/urls';
import { formatMoney } from '../../../../utils/helpers';

type Props = { moneyDown: number };

const StepperDownPaymentCard = ({ moneyDown }: Props) => (
  <Card borderRadius="24px" p={2}>
    <Text
      p={2}
      fontSize={{ base: 'lg', md: 'xl' }}
      fontWeight="700"
      color="leaseEndBlue"
      letterSpacing="wider"
    >
      Down Payment Due
    </Text>

    <CardBody p={4} bgColor="grayCoolLight" borderRadius="16px">
      <Flex flexDir="column" gap={4}>
        <Box>
          <Text fontSize="sm" fontWeight="800" color="gray.500">
            Payment Due Now:
          </Text>
          <Text fontSize="4xl" fontWeight="800" color="leaseEndBlue">
            {formatMoney(moneyDown)}
          </Text>
        </Box>
        <Button as={RRLink} fontWeight="700" letterSpacing="wider" w="full" to={PAYMENTS_DASHBOARD}>
          MAKE PAYMENT
        </Button>
        <Text fontSize="xs" color="gray.500" fontStyle="italic">
          *Payments already made may not be reflected here
        </Text>
      </Flex>
    </CardBody>
  </Card>
);

export default StepperDownPaymentCard;
